import React from "react";
import './Clients.css';
import '../../App.css';
import Menu from '../../components/menu/Menu'
import MobileMenu from '../../components/mobile_tabmennu/MobileMenu'
import Footer from "../../components/Footer/Footer";
import InfiniteSlider from '../service/InfiniteSlider';


const Clients=()=>{

    return(
        <div className='clients-main-div'>
            <div className='app-pc-menu'>
                    <Menu page={'CLIENTS'}/>
                    </div>
                    <div className='app-mobile-menu'>
                    <MobileMenu/>
                </div>


            <div className='client-header-details-container'>
                   <p className='client-header-text'>Our Trusted Clients</p> 
                   <h2 className='client-header-text2' style={{marginBottom:"1rem", textAlign:'center'}}>Partnering with industry leaders worldwide</h2> 
                   <div>
                   <InfiniteSlider animationSpeed="20s" />
                   </div>
            </div> 

               <Footer/> 
        </div>
    )
}


export default Clients;